<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <custom-tabs v-model="tabs" class="mb-2 rounded-lg" grow>
          <template v-slot:staticTabs>
            <v-tab
              v-for="(item, i) in mediaObj"
              :href="`#${i}`"
              :ripple="false"
              :key="i"
            >
              <div
                class="d-flex align-center justify-center"
                style="width: 100%;"
              >
                <div class="cornel-left"></div>
                <div class="cornel-right"></div>
                
                <v-icon class="ml-2" v-if="item.icon">{{ item.icon }}</v-icon>
                <span>{{ item.title }}</span>
                
                <help-info
                  :element-name="`${serviceName}-${componentName}-tab-${i}`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo mr-2"
                  :label="`${item.title}`"
                />
              </div>
            </v-tab>
          </template>


          <template v-slot:staticItems>
            <v-tab-item v-for="(item, i) in mediaObj" :key="i" :value="i">
              <v-card class="d-flex flex-wrap" flat>
                <template v-for="(media, j) in item.items">
                  <div class="rowinfo" :key="j">
                    <v-tooltip
                      class="contentinfo"
                      :key="j"
                      :color="
                        media.attrs
                          ? media.attrs.hover
                            ? media.attrs.hover
                            : media.attrs.fgColor
                          : ''
                      "
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-hover v-if="media.attrs" v-slot="{ hover }">
                          <div
                            :style="
                              hover
                                ? `background: ${
                                    media.attrs.hover
                                      ? media.attrs.hover
                                      : media.attrs.fgColor
                                  }`
                                : ''
                            "
                            class="m-2 p-3 qrBtn"
                            v-bind="attrs"
                            @click="addSocial(media)"
                            v-on="on"
                          >
                            <svg-base
                              :height="media.height"
                              :view-box="media.viewBox"
                              :width="media.width"
                            >
                              <component
                                :is="media.svg"
                                v-bind="hover ? media.attrs : ''"
                              />
                            </svg-base>
                          </div>
                        </v-hover>

                        <div
                          v-else
                          class="m-2 p-3 qrBtn"
                          v-bind="attrs"
                          @click="addSocial(media)"
                          v-on="on"
                        >
                          <img
                            :alt="media.text"
                            :src="media.img"
                            style="aspect-ratio: 1; object-fit: cover"
                            width="40"
                          />
                        </div>
                      </template>

                      <span>{{ media.label }}</span>
                    </v-tooltip>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-media`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('social_network')"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </template>
              </v-card>
            </v-tab-item>
          </template>
        </custom-tabs>

        <v-row no-gutters>
          <v-col
            v-for="(val, i) in socialMedia"
            :key="i"
            class="pt-2"
            cols="12"
            style="border-bottom: 1px dashed #7e8299"
          >
            <p>{{ val[0] ? val[0].label : "" }}</p>

            <div>
              <div v-for="(item, index) in val" :key="index">
                <template v-if="$vuetify.breakpoint.mobile">
                  <template
                    v-for="(media, ind) in flattenObj.filter(
                      (x) => x.svg === item.svg,
                    )"
                  >
                    <svg-base
                      v-if="media.attrs"
                      :height="media.height"
                      :view-box="media.viewBox"
                      :width="media.width"
                      class="mt-0"
                      :key="ind"
                    >
                      <component :is="media.svg" class="mt-0" />
                    </svg-base>
                    <div
                      v-else
                      class="mx-2"
                      @click="addSocial(media)"
                      :key="ind"
                    >
                      <img
                        :alt="media.text"
                        :src="media.img"
                        style="object-fit: cover"
                        width="40"
                      />
                    </div>
                  </template>

                  <v-btn icon @click="removeFromList(index, i)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <div class="rowinfo pa-2">
                  <div class="contentinfo d-flex row flex-nowrap">
                    <v-text-field
                      v-model="item.url"
                      :append-outer-icon="
                        $vuetify.breakpoint.mobile ? '' : 'mdi-delete'
                      "
                      :messages="item.hint"
                      :placeholder="item.hint"
                      clearable
                      dense
                      direction="ltr"
                      outlined
                      style="direction: ltr"
                      v-bind="$attrs"
                      @click:append-outer="removeFromList(index, i)"
                    >
                      <template v-slot:prepend-inner>
                        <v-card
                          class="d-flex align-center px-2"
                          color="grey lighten-2"
                          flat
                          height="40"
                          width="fit-content"
                        >
                          <v-icon v-if="item.prefix.startsWith('mdi')">{{
                            item.prefix
                          }}</v-icon>
                          <span v-else>{{ item.prefix }}</span>
                        </v-card>
                      </template>

                      <template
                        v-for="(media, ind2) in flattenObj.filter(
                          (x) => x.svg === item.svg,
                        )"
                        v-if="!$vuetify.breakpoint.mobile"
                        v-slot:prepend
                      >
                        <svg-base
                          v-if="media.attrs"
                          :height="media.height"
                          :view-box="media.viewBox"
                          :width="media.width"
                          class="mt-0"
                          :key="ind2"
                        >
                          <component :is="media.svg" class="mt-0" />
                        </svg-base>
                        <div
                          v-else
                          class="mx-2"
                          @click="addSocial(media)"
                          :key="ind2"
                        >
                          <img
                            :alt="media.text"
                            :src="media.img"
                            style="object-fit: cover"
                            width="40"
                          />
                        </div>
                      </template>
                    </v-text-field>
                  </div>
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-socialText`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="val[0] ? val[0].label : ''"
                  />
                </div>
                <div
                  class="rowinfo pa-2"
                  v-if="isSocialRoute"
                >
                  <div class="contentinfo d-flex row flex-nowrap">
                    <v-text-field
                      v-if="isSocialRoute"
                      v-model="item.socialText"
                      :append-outer-icon="
                        $vuetify.breakpoint.mobile ? '' : 'mdi-pen'
                      "
                      class="col-md-11"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      outlined
                      :placeholder="$t('custom_text_placeholder')"
                      style="margin-right: 5.5%"
                      v-bind="$attrs"
                    />
                  </div>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-socialMedia`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('custom_text')"
                  />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import svgBase from "../../../content/svgLoader/svgBase";
import svgFacebook from "../../../content/svgLoader/svgFile/svgFacebook";
import svgDribbble from "../../../content/svgLoader/svgFile/svgDribbble";
import svgPinterest from "../../../content/svgLoader/svgFile/svgPinterest";
import svgTelegram from "../../../content/svgLoader/svgFile/svgTelegram";
import svgWhatsapp from "../../../content/svgLoader/svgFile/svgWhatsapp";
import svgInstagram from "../../../content/svgLoader/svgFile/svgInstagram";
import svgGithub from "../../../content/svgLoader/svgFile/svgGithub";
import svgTiktok from "../../../content/svgLoader/svgFile/svgTiktok";
import svgEmail from "../../../content/svgLoader/svgFile/svgEmail";
import svgLocation from "../../../content/svgLoader/svgFile/svgLocation";
import svgEitaa from "../../../content/svgLoader/svgFile/pr/svgEitaa";
import svgSoroush from "../../../content/svgLoader/svgFile/pr/svgSoroush";
import svgBale from "../../../content/svgLoader/svgFile/pr/svgBale";
import svgLinkedin from "../../../content/svgLoader/svgFile/svgLinkedin";
import svgLinkedinCo from "../../../content/svgLoader/svgFile/svgLinkedinCo";
import svgAparat from "../../../content/svgLoader/svgFile/pr/svgAparat";
import svgGap from "../../../content/svgLoader/svgFile/pr/svgGap";
import svgDivar from "../../../content/svgLoader/svgFile/pr/svgDivar";
import svgSheypour from "../../../content/svgLoader/svgFile/pr/svgSheypour";
import svgTwitter from "../../../content/svgLoader/svgFile/svgTwitter";
import svgSkype from "../../../content/svgLoader/svgFile/svgSkype";
import svgYoutube from "../../../content/svgLoader/svgFile/svgYoutube";
import svgWechat from "../../../content/svgLoader/svgFile/svgWechat";
import svgViber from "../../../content/svgLoader/svgFile/svgViber";
import svgRubika from "../../../content/svgLoader/svgFile/pr/svgRubika";
import svgThreads from "../../../content/svgLoader/svgFile/svgThreads";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import svgDigikala from "../../../content/svgLoader/svgFile/pr/svgDigikala";
import svgBasalam from "../../../content/svgLoader/svgFile/pr/svgBasalam";
import svgSnappshop from "../../../content/svgLoader/svgFile/pr/svgSnappshop";
import svgTechnolife from "../../../content/svgLoader/svgFile/pr/svgTechnolife";
import svgTorob from "../../../content/svgLoader/svgFile/pr/svgTorob";
import svgEmalls from "../../../content/svgLoader/svgFile/pr/svgEmalls";
import svgAmazonstore from "../../otherQrTypes/applicaion/cm/svgAmazonstore.vue";
import svgCafebazaar from "../../../content/svgLoader/svgFile/pr/svgCafebazaar.vue";
// import svgSamsung from "../../../content/svgLoader/svgFile/pr/svgSamsung.vue";
import svgGoogleplay from "../../otherQrTypes/applicaion/cm/svgGoogleplay.vue";
import { Bus } from "../../../../main";
// import svgApple from "../../../content/svgLoader/svgFile/pr/svgApple.vue";
import svgApple from "../../otherQrTypes/applicaion/cm/svgAppstore.vue";
import svgSamsung from "../../otherQrTypes/applicaion/cm/svgSamsungstore.vue";
import svgMyket from "../../otherQrTypes/applicaion/cm/svgMyket.vue";
import svgVivostore from "../../otherQrTypes/applicaion/cm/svgVivostore.vue";


export default {
  name: "socialMediaIcons",

  components: {
    QrAddressField,
    svgBase,
    svgFacebook,
    svgDribbble,
    svgPinterest,
    svgTelegram,
    svgWhatsapp,
    svgInstagram,
    svgGithub,
    svgTiktok,
    svgEmail,
    svgLocation,
    svgEitaa,
    svgSoroush,
    svgBale,
    svgLinkedin,
    svgAparat,
    svgGap,
    svgDivar,
    svgSheypour,
    svgTwitter,
    svgSkype,
    svgYoutube,
    svgWechat,
    svgViber,
    svgRubika,
    svgThreads,
    svgLinkedinCo,
    svgDigikala,
    svgBasalam,
    svgSnappshop,
    svgTechnolife,
    svgTorob,
    svgEmalls,
    svgApple,
    svgSamsung,
    svgCafebazaar,
    svgGoogleplay
  },

  props: {
    value: {
      type: Object,
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "socialMediaIcons",
      model: "",
      tabs: "",

      socialMedia: {},
    };
  },

  mounted() {
    let flattenMedia = [].concat(
      ...Object.values(this.mediaObj).map((item) => item.items),
    );

    this.$root.$on("clearDefaultData", this.clearDefaults);

    Object.entries(this.value).forEach(([key, value]) => {
      value.forEach((item) => {
        const mediaItem = flattenMedia.find((item) => item.value === key);
        item.prefix = mediaItem?.prefix;
        item.pattern = mediaItem?.pattern;
        item.label = mediaItem?.label;
        item.hint = mediaItem?.hint;
      });
    });

    this.socialMedia = this.value;
  },

  computed: {
    isSocialRoute(){
    return ['qr.create.editSocialModel',
    'qr.create.SocialMediaModel',
    'qr.socialMedia','qr.name.id.editSocial',
    'qr.name.editSocial'].includes(this.$route.name);
    },
    mediaObj() {
      return {
        persianMedia: {
          title: this.$t("iranian_social_networks"),
          icon: "mdi-forum-outline", 
          items: [
            {
              label: this.$t("aparat"),
              text: this.$t("aparat_hint"),
              hint: this.$t("aparat_hint"),
              socialText: "",
              value: "aparat",
              pattern: "www.aparat.com/",
              prefix: "@",
              svg: "svgAparat",
              img: "/media/socialIcon/40icon/pr/aparat.svg",
              attrs: { fgColor: "#fff", hover: "#ed145b" },
              viewBox: 40,
            },
            {
              label: this.$t("eitaa"),
              text: this.$t("eitaa_hint"),
              hint: this.$t("eitaa_hint"),
              socialText: "",
              value: "eitaa",
              pattern: "https://eitaa.com/",
              prefix: "@",
              svg: "svgEitaa",
              img: "/media/socialIcon/40icon/pr/eitaa.svg",
              attrs: { fgColor: "#fff", hover: "#e88214" },
            },
            {
              label: this.$t("soroush"),
              text: this.$t("soroush_hint"),
              hint: this.$t("soroush_hint"),
              socialText: "",
              value: "soroush",
              pattern: "https://splus.ir/",
              prefix: "@",
              svg: "svgSoroush",
              img: "/media/socialIcon/40icon/pr/soroush.svg",
              attrs: { fgColor: "#fff", hover: "#26758e" },
            },
            {
              label: this.$t("bale"),
              text: this.$t("bale_hint"),
              hint: this.$t("bale_hint"),
              socialText: "",
              value: "bale",
              pattern: "https://ble.ir/",
              prefix: "@",
              svg: "svgBale",
              img: "/media/socialIcon/40icon/pr/bale.svg",
              attrs: { fgColor: "#fff", hover: "#355d84" },
            },
            {
              label: this.$t("rubika"),
              text: this.$t("rubika_hint"),
              hint: this.$t("rubika_hint"),
              socialText: "",
              value: "rubika",
              pattern: "",
              prefix: "URL",
              svg: "svgRubika",
              img: "/media/socialIcon/40icon/pr/rubika.svg",
              attrs: { fgColor: "#fff", hover: "#c7c7c7" },
            },
            {
              label: this.$t("gap"),
              text: this.$t("gap_hint"),
              hint: this.$t("gap_hint"),
              socialText: "",
              value: "gap",
              pattern: "https://gap.im/",
              prefix: "@",
              svg: "svgGap",
              img: "/media/socialIcon/40icon/pr/gap.svg",
              attrs: { fgColor: "#fff", hover: "#744ccf" },
              viewBox: 40,
            },
          ],
        },
        foreignMedia: {
          title: this.$t("foreign_social_networks"),
            icon: "mdi-earth", 
          items: [
            {
              label: this.$t("instagram"),
              text: this.$t("instagram_hint"),
              hint: this.$t("instagram_hint"),
              socialText: "",
              value: "instagram",
              pattern: "https://instagram.com/",
              prefix: "@",
              svg: "svgInstagram",
              img: "/media/socialIcon/40icon/instagram.svg",
              attrs: { hover: "#cc39a4" },
            },
            {
              label: this.$t("whatsapp"),
              text: this.$t("whatsapp_hint"),
              hint: this.$t("whatsapp_hint"),
              socialText: "",
              value: "whatsapp",
              svg: "svgWhatsapp",
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              attrs: { bgColor: "#fff", fgColor: "#40c351" },
            },
            {
              label: this.$t("linkedin"),
              text: this.$t("linkedin_hint"),
              hint: this.$t("linkedin_hint"),
              socialText: "",
              value: "linkedin",
              pattern: "https://www.linkedin.com/in/",
              prefix: "@",
              svg: "svgLinkedin",
              img: "/media/socialIcon/40icon/linkedin.svg",
              attrs: { hover: "#0288D1" },
            },
            {
              label: this.$t("linkedin_company"),
              text: this.$t("linkedin_company_hint"),
              hint: this.$t("linkedin_company_hint"),
              value: "linkedin_company",
              pattern: "https://www.linkedin.com/company/",
              prefix: "Co",
              svg: "svgLinkedinCo",
              img: "/media/socialIcon/40icon/linkedin-co.svg",
              attrs: { hover: "#0076B5C7" },
            },
            {
              label: this.$t("telegram"),
              text: this.$t("telegram_hint"),
              hint: this.$t("telegram_hint"),
              socialText: "",
              value: "telegram",
              svg: "svgTelegram",
              pattern: "https://t.me/",
              prefix: "@",
              img: "/media/socialIcon/40icon/telegram_app.svg",
              attrs: { bgColor: "#fff", fgColor: "#29b6f6" },
            },
            {
              label: this.$t("pinterest"),
              text: this.$t("pinterest_hint"),
              hint: this.$t("pinterest_hint"),
              socialText: "",
              value: "pinterest",
              pattern: "https://www.pinterest.com/",
              prefix: "@",
              svg: "svgPinterest",
              img: "/media/socialIcon/40icon/pinterest.svg",
              attrs: { bgColor: "#fff", fgColor: "#E60023" },
            },
            {
              label: this.$t("dribbble"),
              text: this.$t("dribbble_hint"),
              hint: this.$t("dribbble_hint"),
              socialText: "",
              value: "dribbble",
              pattern: "https://www.dribble.com/",
              prefix: "@",
              svg: "svgDribbble",
              img: "/media/socialIcon/40icon/dribbble.svg",
              attrs: { bgColor: "#fff", fgColor: "#bd1949", hover: "#ed3675" },
            },
            {
              label: this.$t("facebook"),
              text: this.$t("facebook_hint"),
              hint: this.$t("facebook_hint"),
              socialText: "",
              value: "facebook",
              svg: "svgFacebook",
              pattern: "https://www.facebook.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/facebook_messenger.svg",
              attrs: { bgColor: "#fff", fgColor: "#448AFF" },
            },
            {
              label: this.$t("github"),
              text: this.$t("github_hint"),
              hint: this.$t("github_hint"),
              socialText: "",
              value: "github",
              pattern: "https://www.github.com/",
              prefix: "@",
              svg: "svgGithub",
              img: "/media/socialIcon/40icon/github.svg",
              attrs: { bgColor: "#fff", fgColor: "#161414" },
              viewBox: 32,
            },
            {
              label: this.$t("threads"),
              text: this.$t("threads_hint"),
              hint: this.$t("threads_hint"),
              socialText: "",
              value: "threads",
              pattern: "https://www.threads.net/@",
              prefix: "@",
              svg: "svgThreads",
              img: "/media/socialIcon/40icon/threads.svg",
              attrs: { bgColor: "#fff", fgColor: "#000" },
              viewBox: 42,
            },
            {
              label: this.$t("tiktok"),
              text: this.$t("tiktok_hint"),
              hint: this.$t("tiktok_hint"),
              socialText: "",
              value: "tiktok",
              svg: "svgTiktok",
              pattern: "https://www.tiktok.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/tiktok.svg",
              attrs: { fgColor: "#fff", hover: "#212121" },
            },
            {
              label: this.$t("twitter"),
              text: this.$t("twitter_hint"),
              hint: this.$t("twitter_hint"),
              socialText: "",
              value: "twitter",
              svg: "svgTwitter",
              pattern: "https://twitter.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/twitter.svg",
              attrs: { fgColor: "#fff", hover: "#03A9F4" },
            },
            {
              label: this.$t("skype"),
              text: this.$t("skype_hint"),
              hint: this.$t("skype_hint"),
              socialText: "",
              value: "skype",
              svg: "svgSkype",
              pattern: "https://www.skype.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/skype.svg",
              attrs: { fgColor: "#fff", hover: "#03A9F4" },
              viewBox: 40,
            },
            {
              label: this.$t("youtube"),
              text: this.$t("youtube_hint"),
              hint: this.$t("youtube_hint"),
              socialText: "",
              value: "youtube",
              svg: "svgYoutube",
              pattern: "https://youtube.com/@",
              prefix: "@",
              img: "/media/socialIcon/40icon/youtube.svg",
              attrs: { fgColor: "#fff", hover: "#FF0000" },
              viewBox: 40,
            },
            {
              label: this.$t("wechat"),
              text: this.$t("wechat_hint"),
              hint: this.$t("wechat_hint"),
              socialText: "",
              value: "wechat",
              svg: "svgWechat",
              pattern: "https://www.wechat.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/wechat.svg",
              attrs: { fgColor: "#fff", hover: "#8BC34A" },
              viewBox: 40,
            },
            {
              label: this.$t("viber"),
              text: this.$t("viber_hint"),
              hint: this.$t("viber_hint"),
              socialText: "",
              value: "viber",
              svg: "svgViber",
              pattern: "https://www.viber.com/",
              prefix: "@",
              img: "/media/socialIcon/40icon/viber.svg",
              attrs: { fgColor: "#fff", hover: "#7E57C2" },
              viewBox: 40,
            },
          ],
        },
        ads: {
            title: this.$t("edit_bpage_special_info_special.advertising_sites"),
            icon: "mdi-bullhorn-outline",
            items: [
              {
                label: this.$t("edit_bpage_special_info_special.divar"),
                text: this.$t("edit_bpage_special_info_special.divar_hint"),
                hint: this.$t("edit_bpage_special_info_special.divar_hint"),
                socialText: "",
                value: "divar",
                svg: "svgDivar",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/divar.svg",
                attrs: { fgColor: "#fff", hover: "#a62626" },
                viewBox: "0 0 40 24.33",
              },
              {
                label: this.$t("edit_bpage_special_info_special.sheypoor"),
                text: this.$t("edit_bpage_special_info_special.sheypoor_hint"),
                hint: this.$t("edit_bpage_special_info_special.sheypoor_hint"),
                socialText: "",
                value: "sheypoor",
                svg: "svgSheypour",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/sheypour.svg",
                attrs: { fgColor: "#fff", hover: "#0073f3" },
                viewBox: 40,
              },
              {
                label: this.$t("edit_bpage_special_info_special.digikala"),
                text: this.$t("edit_bpage_special_info_special.digikala_hint"),
                hint: this.$t("edit_bpage_special_info_special.digikala_hint"),
                socialText: "",
                value: "digikala",
                svg: "svgDigikala",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/digikala.svg",
                attrs: { fgColor: "#fff", hover: "#ef394e" },
                viewBox: "0.00 0.00 1080.00 1080.00",
              },
              {
                label: this.$t("edit_bpage_special_info_special.basalam"),
                text: this.$t("edit_bpage_special_info_special.basalam_hint"),
                hint: this.$t("edit_bpage_special_info_special.basalam_hint"),
                socialText: "",
                value: "basalam",
                svg: "svgBasalam",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/basalam.svg",
                attrs: { fgColor: "#fff", hover: "#FF5C39" },
                viewBox: "0 0 128 208",
              },
              {
                label: this.$t("edit_bpage_special_info_special.snappshop"),
                text: this.$t("edit_bpage_special_info_special.snappshop_hint"),
                hint: this.$t("edit_bpage_special_info_special.snappshop_hint"),
                socialText: "",
                value: "snappshop",
                svg: "svgSnappshop",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/snappshop.svg",
                attrs: { fgColor: "#fff", hover: "#B400AE" },
                viewBox: "0 0 69 40",
              },
              {
                label: this.$t("edit_bpage_special_info_special.technolife"),
                text: this.$t("edit_bpage_special_info_special.technolife_hint"),
                hint: this.$t("edit_bpage_special_info_special.technolife_hint"),
                socialText: "",
                value: "technolife",
                svg: "svgTechnolife",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/technolife.svg",
                attrs: { fgColor: "#fff", hover: "#26487e" },
                viewBox: "0 0 112 42",
              },
              {
                label: this.$t("edit_bpage_special_info_special.torob"),
                text: this.$t("edit_bpage_special_info_special.torob_hint"),
                hint: this.$t("edit_bpage_special_info_special.torob_hint"),
                socialText: "",
                value: "torob",
                svg: "svgTorob",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/torob.svg",
                attrs: { fgColor: "#fff", hover: "#d62020" },
                viewBox: "0.00 0.00 130.00 130.00",
              },
              {
                label: this.$t("edit_bpage_special_info_special.emalls"),
                text: this.$t("edit_bpage_special_info_special.emalls_hint"),
                hint: this.$t("edit_bpage_special_info_special.emalls_hint"),
                socialText: "",
                value: "emalls",
                svg: "svgEmalls",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/Emalls.svg",
                attrs: { fgColor: "#fff", hover: "#fd564a" },
                viewBox: "0.00 0.00 300.00 78.00",
              },
            ],
          },

          stores: {
            title: this.$t("edit_bpage_special_info_special.stores"),
            icon: "mdi-storefront-outline",
            items: [
              {
                svg: "svgCafebazaar",
                attrs: { fgColor: "#fff", hover: "#5BEA3B" },
                label: this.$t("edit_bpage_special_info_special.cafebazaar"),
                text: this.$t("edit_bpage_special_info_special.cafebazaar_hint"),
                hint: this.$t("edit_bpage_special_info_special.cafebazaar_hint"),
                socialText: "",
                value: "cafebazaar",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/cafebazaar.svg",
                viewBox: "0.00 0.00 303.00 132.00",
              },
              {
                label: this.$t("edit_bpage_special_info_special.googleplay"),
                text: this.$t("edit_bpage_special_info_special.googleplay_hint"),
                hint: this.$t("edit_bpage_special_info_special.googleplay_hint"),
                socialText: "",
                value: "googleplay",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/googleplay.svg",
                viewBox: "0 -4.447 361.403 408.86699999999996",
                svg: "svgGoogleplay",
                attrs: { fgColor: "#fff", hover: "#1394FE" },
              },
              {
                label: this.$t("edit_bpage_special_info_special.samsung"),
                text: this.$t("edit_bpage_special_info_special.samsung_hint"),
                hint: this.$t("edit_bpage_special_info_special.samsung_hint"),
                socialText: "",
                value: "samsung",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/samsung.svg",
                svg: "svgSamsung",
                attrs: {
                  fgColor: "#fff",
                  hover: "#ec3c75",
                  bgColor: "#ec3c75",
                },
                viewBox: "0 0 230 230",
              },
              {
                label: this.$t("edit_bpage_special_info_special.apple"),
                text: this.$t("edit_bpage_special_info_special.apple_hint"),
                hint: this.$t("edit_bpage_special_info_special.apple_hint"),
                socialText: "",
                value: "apple",
                pattern: "",
                prefix: "URL",
                img: "/media/socialIcon/40icon/pr/apple.svg",
                viewBox: "0 0 512 512",
                svg: "svgApple",
                attrs: {
                  fgColor: "#fff",
                  hover: "#2494f4",
                  ggColor: "#2494f4",
                },
              },
            ],
          },
        otherLinks: {
          title: this.$t("other_links"),
          icon: "mdi-link-variant", 
          items: [
            {
              label: this.$t("email"),
              text: this.$t("email_hint"),
              hint: this.$t("email_hint"),
              socialText: "",
              value: "email",
              pattern: "Email",
              prefix: "mdi-gmail",
              svg: "svgEmail",
              img: "/media/socialIcon/40icon/at_sign.svg",
              attrs: { fgColor: "#fff", hover: "#2196F3" },
            },
            {
              label: this.$t("address"),
              text: this.$t("address_hint"),
              hint: this.$t("address_hint"),
              socialText: "",
              value: "address",
              svg: "svgLocation",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/location.svg",
              attrs: { bgColor: "#fff", hover: "#90caf9" },
            },
          ],
        },
      };
    },
    flattenObj() {
      let item = [];
      Object.entries(this.mediaObj).forEach(([key, value]) => {
        item.push(...value.items);
      });
      return item;
    },
  },

  watch: {
    socialMedia: {
      handler(val) {
        Bus.$emit("socialMedias", val);
      },
      deep: true,
    },
  },

  methods: {
    addSocial(media) {
      if (!Object.hasOwn(this.socialMedia, media.value)) {
        let tempObject = {};
        tempObject[media.value] = [];

        this.socialMedia = {
          ...this.socialMedia,
          ...tempObject,
        };
      }

      let obj = {
        hint: media.text,
        label: media.label,
        url: "",
        prefix: media.prefix,
        pattern: media.pattern,
        img: media.img,
        socialText: "",
      };
      if (media.svg) {
        obj.svg = media.svg;
      }

      this.socialMedia[media.value].push(obj);
    },
    removeFromList(value, key) {
      this.socialMedia[key].splice(value, 1);
      if (this.socialMedia[key].length <= 0) {
        delete this.socialMedia[key];
      }
    },
    clearDefaults() {
      this.socialMedia = {};
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.qrBtn {
  border-radius: 4px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}

.v-input >>> .v-input__slot {
  padding-left: 0 !important;
}

.v-input >>> .v-input__prepend-inner {
  margin: 0 !important;
  padding-left: 0;
  padding-right: 4px;
}

.v-input >>> .v-input__prepend-outer {
  margin: 0 !important;
  padding-right: 4px;
}

.v-input >>> .v-input__append-inner {
  padding-left: 15px !important;
}

.v-btn:before,
.v-btn:hover:before {
  opacity: 0 !important;
}
</style>
